/* stop video youtube */
document.querySelector(".tp-leftarrow").addEventListener("click", function() {
  console.log("entro a javascript");
  stopVideos();
});

var divs = document.getElementsByClassName(".philosophy").length;
console.log("Hay " + divs + " elementos");

console.log("entro");

jQuery(document).load(function () {
  jQuery(".tp-leftarrow").click(function(){
    console.log("entro")
  });
});

jQuery(function() {
  jQuery(".tp-leftarrow").click(function(){
    console.log("entro jQuery")
  });
});
function stopVideos() {
  console.log("entro a stopvideos")
	var videos = document.querySelectorAll('iframe, video');
	Array.prototype.forEach.call(videos, function (video) {
		if (video.tagName.toLowerCase() === 'video') {
			video.pause();
		} else {
			var src = video.src;
			video.src = src;
		}
	});
};
/* end stop video youtube */
